import { render } from "./PageIndexFour.vue?vue&type=template&id=22bf8478"
import script from "./PageIndexFour.vue?vue&type=script&lang=js"
export * from "./PageIndexFour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__